import { render, staticRenderFns } from "./SveiConfigurazionePuntiIncontroViewComponent.vue?vue&type=template&id=e9431bb6"
import script from "./SveiConfigurazionePuntiIncontroViewComponent.vue?vue&type=script&lang=js"
export * from "./SveiConfigurazionePuntiIncontroViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports